var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        {
          staticClass: "elevation-6",
          staticStyle: { "margin-top": "70px", float: "right" },
          attrs: {
            color: "white",
            floating: "",
            dense: "",
            flat: "",
            absolute: "",
            top: ""
          }
        },
        [
          _c(
            "v-btn-toggle",
            {
              attrs: { mandatory: "" },
              model: {
                value: _vm.toolbar,
                callback: function($$v) {
                  _vm.toolbar = $$v
                },
                expression: "toolbar"
              }
            },
            [
              _c(
                "v-btn",
                { attrs: { flat: "", value: "select" } },
                [
                  _c("span", [_vm._v("Select")]),
                  _vm._v(" "),
                  _c("v-icon", [_vm._v("select_all")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { flat: "", value: "seat" } },
                [
                  _c("span", [_vm._v("Seat")]),
                  _vm._v(" "),
                  _c("v-icon", [_vm._v("event_seat")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { flat: "", value: "screen" } },
                [
                  _c("span", [_vm._v("Screen")]),
                  _vm._v(" "),
                  _c("v-icon", [_vm._v("format_shapes")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { flat: "", value: "wall" } },
                [
                  _c("span", [_vm._v("Wall")]),
                  _vm._v(" "),
                  _c("v-icon", [_vm._v("format_shapes")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { flat: "", value: "railing" } },
                [
                  _c("span", [_vm._v("Railing")]),
                  _vm._v(" "),
                  _c("v-icon", [_vm._v("format_shapes")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { flat: "", value: "text" } },
                [
                  _c("span", [_vm._v("Text")]),
                  _vm._v(" "),
                  _c("v-icon", [_vm._v("short_text")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider", {
            staticClass: "mx-3",
            attrs: { inset: "", vertical: "" }
          }),
          _vm._v(" "),
          _c("v-switch", {
            staticClass: "mt-3",
            attrs: {
              label: "Score View",
              value: "",
              "input-value": "true",
              color: "blue-grey darken-4"
            },
            model: {
              value: _vm.scoreView,
              callback: function($$v) {
                _vm.scoreView = $$v
              },
              expression: "scoreView"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-canvas",
          style: {
            width: _vm.canvasWidth + "px",
            height: _vm.canvasHeight + "px"
          },
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              _vm.canvasClickAction($event)
            }
          }
        },
        [
          _vm._l(_vm.slots, function(slot, index) {
            return _c("c-seat", {
              key: "st" + index,
              attrs: {
                "my-seat": slot,
                "booking-mode": false,
                "score-view": _vm.scoreView,
                "edit-selected": slot.editSelected
              },
              on: {
                "seat-moved": function($event) {
                  _vm.uiComponentMoved($event, slot)
                },
                "show-seat-context-menu": function($event) {
                  _vm.showContextMenu($event, slot, "seat")
                },
                "show-seat-details": function($event) {
                  _vm.showItemDetailMenu($event, slot, index, "seat")
                },
                "add-seat-to-selection": function($event) {
                  _vm.addToSelection(slot, index)
                }
              }
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.uiComponents, function(uiComponent, index) {
            return [
              uiComponent.type === "SCREEN"
                ? _c("c-screen", {
                    key: "sc" + index,
                    attrs: { "my-screen": uiComponent },
                    on: {
                      "screen-moved": function($event) {
                        _vm.uiComponentMoved($event, uiComponent)
                      },
                      "show-screen-context-menu": function($event) {
                        _vm.showContextMenu($event, uiComponent, "screen")
                      }
                    }
                  })
                : uiComponent.type === "WALL"
                  ? _c("c-wall", {
                      key: "wl" + index,
                      attrs: { "my-wall": uiComponent },
                      on: {
                        "wall-moved": function($event) {
                          _vm.uiComponentMoved($event, uiComponent)
                        },
                        "show-wall-context-menu": function($event) {
                          _vm.showContextMenu($event, uiComponent, "wall")
                        }
                      }
                    })
                  : uiComponent.type === "RAILING"
                    ? _c("c-railing", {
                        key: "rl" + index,
                        attrs: { "my-railing": uiComponent },
                        on: {
                          "railing-moved": function($event) {
                            _vm.uiComponentMoved($event, uiComponent)
                          },
                          "show-railing-context-menu": function($event) {
                            _vm.showContextMenu($event, uiComponent, "railing")
                          }
                        }
                      })
                    : uiComponent.type === "TEXT"
                      ? _c("c-ui-text", {
                          key: "txt" + index,
                          attrs: { "my-text": uiComponent },
                          on: {
                            "text-moved": function($event) {
                              _vm.uiComponentMoved($event, uiComponent)
                            },
                            "show-ui-text-context-menu": function($event) {
                              _vm.showContextMenu($event, uiComponent, "text")
                            },
                            "show-ui-text-details": function($event) {
                              _vm.showItemDetailMenu(
                                $event,
                                uiComponent,
                                index,
                                "text"
                              )
                            }
                          }
                        })
                      : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c(
            "v-menu",
            {
              attrs: {
                "position-x": _vm.cmX,
                "position-y": _vm.cmY,
                "offset-y": "",
                absolute: ""
              },
              model: {
                value: _vm.showMenu,
                callback: function($$v) {
                  _vm.showMenu = $$v
                },
                expression: "showMenu"
              }
            },
            [
              _c(
                "v-list",
                _vm._l(_vm.seatCM, function(item, index) {
                  return _c(
                    "v-list-tile",
                    {
                      key: "mnu" + index,
                      on: {
                        click: function($event) {
                          _vm.seatCMAction(_vm.selectedItem, item.menuAction)
                        }
                      }
                    },
                    [
                      item.icon !== ""
                        ? _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-list-tile-title", [_vm._v(_vm._s(item.title))])
                    ],
                    1
                  )
                })
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showItemDetails,
                  expression: "showItemDetails"
                }
              ],
              staticClass: "selected-item-details elevation-6"
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "px-0 mx-0 py-0",
                          attrs: { "grid-list-md": "" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _vm.isSeatField && _vm.isMultiAssignable
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          counter: 2,
                                          maxlength: "2",
                                          label: "Row",
                                          required: ""
                                        },
                                        on: {
                                          blur: function($event) {
                                            _vm.validateSeatNames(
                                              _vm.selectedItem
                                            )
                                          },
                                          keyup: function($event) {
                                            _vm.updateMultipleItems("rowLabel")
                                          }
                                        },
                                        model: {
                                          value: _vm.multiSelectedItem.rowLabel,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.multiSelectedItem,
                                              "rowLabel",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "multiSelectedItem.rowLabel"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm.isSeatField
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs6: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            counter: 2,
                                            maxlength: "2",
                                            label: "Row",
                                            required: ""
                                          },
                                          on: {
                                            blur: function($event) {
                                              _vm.validateSeatNames(
                                                _vm.selectedItem
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.selectedItem.rowLabel,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectedItem,
                                                "rowLabel",
                                                $$v
                                              )
                                            },
                                            expression: "selectedItem.rowLabel"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              _vm._v(" "),
                              _vm.isSeatField && _vm.isMultiAssignable
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          counter: 3,
                                          maxlength: "3",
                                          label: "Slot Number",
                                          disabled: "",
                                          required: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm.isSeatField
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs6: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            counter: 3,
                                            maxlength: "3",
                                            label: "Slot Number",
                                            disabled: _vm.isMultiAssignable,
                                            required: ""
                                          },
                                          on: {
                                            blur: function($event) {
                                              _vm.validateSeatNames(
                                                _vm.selectedItem
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.selectedItem.slotNumber,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectedItem,
                                                "slotNumber",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "selectedItem.slotNumber"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              _vm._v(" "),
                              _vm.isSeatField && _vm.isMultiAssignable
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.slotCategories,
                                          "item-text": "name",
                                          "item-value": "id",
                                          label: "Category",
                                          auto: ""
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.updateMultipleItems(
                                              "slotCategory"
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.multiSelectedItem.slotCategory
                                              .id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.multiSelectedItem
                                                .slotCategory,
                                              "id",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "multiSelectedItem.slotCategory.id"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm.isSeatField
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs6: "" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.slotCategories,
                                            "item-text": "name",
                                            "item-value": "id",
                                            label: "Category",
                                            auto: ""
                                          },
                                          model: {
                                            value:
                                              _vm.selectedItem.slotCategory.id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectedItem.slotCategory,
                                                "id",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "selectedItem.slotCategory.id"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              _vm._v(" "),
                              _vm.isSeatField && _vm.isMultiAssignable
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.slotStatuses,
                                          label: "Status",
                                          auto: ""
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.updateMultipleItems("status")
                                          }
                                        },
                                        model: {
                                          value: _vm.multiSelectedItem.status,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.multiSelectedItem,
                                              "status",
                                              $$v
                                            )
                                          },
                                          expression: "multiSelectedItem.status"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm.isSeatField
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs6: "" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.slotStatuses,
                                            label: "Status",
                                            auto: ""
                                          },
                                          model: {
                                            value: _vm.selectedItem.status,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectedItem,
                                                "status",
                                                $$v
                                              )
                                            },
                                            expression: "selectedItem.status"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              _vm._v(" "),
                              _vm.isSeatUnderRepair && _vm.isMultiAssignable
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          ref: "repairStartDateMenu",
                                          attrs: {
                                            lazy: "",
                                            "close-on-content-click": false,
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "full-width": "",
                                            "nudge-right": 40,
                                            "min-width": "290px",
                                            "return-value":
                                              _vm.multiSelectedItem
                                                .repairStartDate
                                          },
                                          on: {
                                            "update:returnValue": function(
                                              $event
                                            ) {
                                              _vm.$set(
                                                _vm.multiSelectedItem,
                                                "repairStartDate",
                                                $event
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.repairStartDateMenu,
                                            callback: function($$v) {
                                              _vm.repairStartDateMenu = $$v
                                            },
                                            expression: "repairStartDateMenu"
                                          }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              slot: "activator",
                                              label: "From",
                                              "prepend-icon": "event",
                                              required: "",
                                              readonly: ""
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.updateMultipleItems(
                                                  "repairStartDate"
                                                )
                                              }
                                            },
                                            slot: "activator",
                                            model: {
                                              value:
                                                _vm.multiSelectedItem
                                                  .repairStartDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.multiSelectedItem,
                                                  "repairStartDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "multiSelectedItem.repairStartDate"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-date-picker",
                                            {
                                              attrs: {
                                                "no-title": "",
                                                scrollable: ""
                                              },
                                              model: {
                                                value:
                                                  _vm.multiSelectedItem
                                                    .repairStartDate,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.multiSelectedItem,
                                                    "repairStartDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "multiSelectedItem.repairStartDate"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    flat: "",
                                                    color: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.repairStartDateMenu = false
                                                    }
                                                  }
                                                },
                                                [_vm._v("Cancel")]
                                              ),
                                              _vm._v(" "),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    flat: "",
                                                    color: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$refs.repairStartDateMenu.save(
                                                        _vm.multiSelectedItem
                                                          .repairStartDate
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("OK")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm.isSeatUnderRepair
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs6: "" } },
                                      [
                                        _c(
                                          "v-menu",
                                          {
                                            ref: "repairStartDateMenu",
                                            attrs: {
                                              lazy: "",
                                              "close-on-content-click": false,
                                              transition: "scale-transition",
                                              "offset-y": "",
                                              "full-width": "",
                                              "nudge-right": 40,
                                              "min-width": "290px",
                                              "return-value":
                                                _vm.selectedItem.repairStartDate
                                            },
                                            on: {
                                              "update:returnValue": function(
                                                $event
                                              ) {
                                                _vm.$set(
                                                  _vm.selectedItem,
                                                  "repairStartDate",
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.repairStartDateMenu,
                                              callback: function($$v) {
                                                _vm.repairStartDateMenu = $$v
                                              },
                                              expression: "repairStartDateMenu"
                                            }
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                slot: "activator",
                                                label: "From",
                                                "prepend-icon": "event",
                                                required: "",
                                                readonly: ""
                                              },
                                              slot: "activator",
                                              model: {
                                                value:
                                                  _vm.selectedItem
                                                    .repairStartDate,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.selectedItem,
                                                    "repairStartDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedItem.repairStartDate"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "v-date-picker",
                                              {
                                                attrs: {
                                                  "no-title": "",
                                                  scrollable: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.selectedItem
                                                      .repairStartDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.selectedItem,
                                                      "repairStartDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "selectedItem.repairStartDate"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.repairStartDateMenu = false
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                _c("v-spacer"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.$refs.repairStartDateMenu.save(
                                                          _vm.selectedItem
                                                            .repairStartDate
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("OK")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              _vm._v(" "),
                              _vm.isSeatUnderRepair && _vm.isMultiAssignable
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          ref: "repairEndDateMenu",
                                          attrs: {
                                            lazy: "",
                                            "close-on-content-click": false,
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "full-width": "",
                                            "nudge-right": 40,
                                            "min-width": "290px",
                                            "return-value":
                                              _vm.multiSelectedItem
                                                .repairEndDate
                                          },
                                          on: {
                                            "update:returnValue": function(
                                              $event
                                            ) {
                                              _vm.$set(
                                                _vm.multiSelectedItem,
                                                "repairEndDate",
                                                $event
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.repairEndDateMenu,
                                            callback: function($$v) {
                                              _vm.repairEndDateMenu = $$v
                                            },
                                            expression: "repairEndDateMenu"
                                          }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              slot: "activator",
                                              label: "To",
                                              "prepend-icon": "event",
                                              required: "",
                                              readonly: ""
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.updateMultipleItems(
                                                  "repairEndDate"
                                                )
                                              }
                                            },
                                            slot: "activator",
                                            model: {
                                              value:
                                                _vm.multiSelectedItem
                                                  .repairEndDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.multiSelectedItem,
                                                  "repairEndDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "multiSelectedItem.repairEndDate"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-date-picker",
                                            {
                                              attrs: {
                                                "no-title": "",
                                                scrollable: ""
                                              },
                                              model: {
                                                value:
                                                  _vm.multiSelectedItem
                                                    .repairEndDate,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.multiSelectedItem,
                                                    "repairEndDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "multiSelectedItem.repairEndDate"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    flat: "",
                                                    color: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.repairEndDateMenu = false
                                                    }
                                                  }
                                                },
                                                [_vm._v("Cancel")]
                                              ),
                                              _vm._v(" "),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    flat: "",
                                                    color: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$refs.repairEndDateMenu.save(
                                                        _vm.multiSelectedItem
                                                          .repairEndDate
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("OK")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm.isSeatUnderRepair
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs6: "" } },
                                      [
                                        _c(
                                          "v-menu",
                                          {
                                            ref: "repairEndDateMenu",
                                            attrs: {
                                              lazy: "",
                                              "close-on-content-click": false,
                                              transition: "scale-transition",
                                              "offset-y": "",
                                              "full-width": "",
                                              "nudge-right": 40,
                                              "min-width": "290px",
                                              "return-value":
                                                _vm.selectedItem.repairEndDate
                                            },
                                            on: {
                                              "update:returnValue": function(
                                                $event
                                              ) {
                                                _vm.$set(
                                                  _vm.selectedItem,
                                                  "repairEndDate",
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.repairEndDateMenu,
                                              callback: function($$v) {
                                                _vm.repairEndDateMenu = $$v
                                              },
                                              expression: "repairEndDateMenu"
                                            }
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                slot: "activator",
                                                label: "To",
                                                "prepend-icon": "event",
                                                required: "",
                                                readonly: ""
                                              },
                                              slot: "activator",
                                              model: {
                                                value:
                                                  _vm.selectedItem
                                                    .repairEndDate,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.selectedItem,
                                                    "repairEndDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedItem.repairEndDate"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "v-date-picker",
                                              {
                                                attrs: {
                                                  "no-title": "",
                                                  scrollable: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.selectedItem
                                                      .repairEndDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.selectedItem,
                                                      "repairEndDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "selectedItem.repairEndDate"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.repairEndDateMenu = false
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                _c("v-spacer"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.$refs.repairEndDateMenu.save(
                                                          _vm.selectedItem
                                                            .repairEndDate
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("OK")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              _vm._v(" "),
                              _vm.isSeatField && _vm.isMultiAssignable
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.slotCapacities,
                                          label: "Capacity",
                                          "item-text": "text",
                                          "item-value": "capacity",
                                          auto: ""
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.updateMultipleItems("capacity")
                                          }
                                        },
                                        model: {
                                          value: _vm.multiSelectedItem.capacity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.multiSelectedItem,
                                              "capacity",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "multiSelectedItem.capacity"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm.isSeatField
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs6: "" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.slotCapacities,
                                            label: "Capacity",
                                            "item-text": "text",
                                            "item-value": "capacity",
                                            auto: ""
                                          },
                                          model: {
                                            value: _vm.selectedItem.capacity,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectedItem,
                                                "capacity",
                                                $$v
                                              )
                                            },
                                            expression: "selectedItem.capacity"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              _vm._v(" "),
                              _vm.isSeatField && _vm.isMultiAssignable
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "Zone" },
                                        on: {
                                          keyup: function($event) {
                                            _vm.updateMultipleItems("zone")
                                          }
                                        },
                                        model: {
                                          value: _vm.multiSelectedItem.zone,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.multiSelectedItem,
                                              "zone",
                                              $$v
                                            )
                                          },
                                          expression: "multiSelectedItem.zone"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm.isSeatField
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs6: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: { label: "Zone" },
                                          model: {
                                            value: _vm.selectedItem.zone,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectedItem,
                                                "zone",
                                                $$v
                                              )
                                            },
                                            expression: "selectedItem.zone"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              _vm._v(" "),
                              _vm.isSeatField && _vm.isMultiAssignable
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          type: "number",
                                          label: "Seat Score"
                                        },
                                        on: {
                                          keyup: function($event) {
                                            _vm.updateMultipleItems("slotScore")
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.multiSelectedItem.slotScore,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.multiSelectedItem,
                                              "slotScore",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "multiSelectedItem.slotScore"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm.isSeatField
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs6: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            type: "number",
                                            label: "Seat Score"
                                          },
                                          model: {
                                            value: _vm.selectedItem.slotScore,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectedItem,
                                                "slotScore",
                                                $$v
                                              )
                                            },
                                            expression: "selectedItem.slotScore"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              _vm._v(" "),
                              _vm.isSeatField && _vm.isMultiAssignable
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: "Happy Seat",
                                          "false-value": 0,
                                          "true-value": 1
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.updateMultipleItems(
                                              "managerReserved"
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.multiSelectedItem
                                              .managerReserved,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.multiSelectedItem,
                                              "managerReserved",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "multiSelectedItem.managerReserved"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm.isSeatField
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs6: "" } },
                                      [
                                        _c("v-switch", {
                                          attrs: {
                                            label: "Happy Seat",
                                            "false-value": 0,
                                            "true-value": 1
                                          },
                                          model: {
                                            value:
                                              _vm.selectedItem.managerReserved,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectedItem,
                                                "managerReserved",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "selectedItem.managerReserved"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              _vm._v(" "),
                              _vm.isUITextField && _vm.isMultiAssignable
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "Text" },
                                        on: {
                                          keyup: function($event) {
                                            _vm.updateMultipleItems("label")
                                          }
                                        },
                                        model: {
                                          value: _vm.multiSelectedItem.label,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.multiSelectedItem,
                                              "label",
                                              $$v
                                            )
                                          },
                                          expression: "multiSelectedItem.label"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm.isUITextField
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: { label: "Text" },
                                          model: {
                                            value: _vm.selectedItem.label,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectedItem,
                                                "label",
                                                $$v
                                              )
                                            },
                                            expression: "selectedItem.label"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              _vm._v(" "),
                              _vm.isSeatField && _vm.isMultiAssignable
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Technical Name",
                                          required: ""
                                        },
                                        on: {
                                          keyup: function($event) {
                                            _vm.updateMultipleItems(
                                              "technicalName"
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.multiSelectedItem.technicalName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.multiSelectedItem,
                                              "technicalName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "multiSelectedItem.technicalName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm.isSeatField
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs6: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: "Technical Name",
                                            required: ""
                                          },
                                          model: {
                                            value:
                                              _vm.selectedItem.technicalName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectedItem,
                                                "technicalName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "selectedItem.technicalName"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bc4722b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bc4722b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/FloorPlanDesigner.vue
// module id = null
// module chunks = 